import PropTypes from "prop-types";

export const ControllerRow = ({ children }) => (
  <div className="border-bottom border-primary border-2 pt-2 pb-2 mb-2">
    {children}
  </div>
);

ControllerRow.propTypes = {
  children: PropTypes.element.isRequired,
};
